import { Directive, ElementRef, Input } from '@angular/core';

import { SubscriberService } from '@services';
import { flatten, includes } from 'lodash';


@Directive({
  selector: '[showByBrand]'
})
export class ShowByBrandDirective {

  constructor(
    private elementRef: ElementRef,
    private subscriberService: SubscriberService
  ) {
  }

  @Input('showByBrand') set brands(brands: string | string[]) {
    const currentBrand = this.subscriberService.brandInfo();

    if (!includes(flatten([brands]), currentBrand?.brand)) {
      this.elementRef.nativeElement.style.display = 'none';
    }
  }

}
